export default "__VITE_ASSET__DFWCpnTf__"